import { IMedia, IMediaCreate } from "../models/wall";
import { axiosInstance } from "../utils";

export const createDraftParagraphMedia = async (data: IMediaCreate): Promise<IMedia> => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });
  const response = await axiosInstance.post<IMedia>(`/draft-paragraph-medias/`, formData);

  return response.data;
}
export const deleteDraftParagraphMedias = async (id: string): Promise<void> => {
  const response = await axiosInstance.delete(`/draft-paragraph-medias/${id}/`);
}
